module.exports = __webpack_public_path__ + "r-v3/img/cam_off_gray.70cf47b3.svg";